/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import SzczegolyEuslugi from './SzczegolyEuslugi';
import ServicesLayout from '../../../components/ServicesLayout';

/* eslint-disable global-require*/
export default {

  path: '/:prefix',

  async action(ctx) {
    const { query, store } = ctx;
    return {
      title: "Szczegóły e-usługi - e-spdp.pl",
      component: <ServicesLayout active="catalogue" ><SzczegolyEuslugi prefix={ctx.params.prefix} district={query.district} /></ServicesLayout>,
      description: "Szczegóły e-usługi - e-spdp.pl",
    };
  },
};



// WEBPACK FOOTER //
// src/routes/euslugi/szczegolyEuslugi/index.js